<section class="manufacture-main-container">
  <section class="manufacture-hero-section">
    <section class="manufacture-hero-copy">
      <span class="x-large-font font-white">Manufacturers</span>
      <p class="body-font font-white">
        Pharmaceutical manufacturers play a vital roll in healthcare. Essential
        treatments are discovered, developed, and produced to make our lives
        healthier and longer.
      </p>
      <p class="body-font font-white">
        It can be a challenge to forecast demand as prescribing habits change,
        patient levels fluctuate, raw material availability shifts, and drug
        companies enter and exit the market.
      </p>
    </section>
    <section class="manufacture-hero-image">
      <img
        src="/assets/img/static-pages/medshorts/MS_Isometric Illustrations_1-01.png"
        alt="Manufacture Graphic Image"
      />
    </section>
  </section>
  <section class="manufacture-main-content-section">
    <p class="body-font">
      With MedShorts, pharmaceutical companies now have a dedicated channel for
      surplus. Instead of<br />
      disposing the drug at a cost, manufacturers may list short-dated stock at
      a discount so that it better aligns<br />
      with the perceived market value. The marketplace is open to all
      commercially available FDA approved<br />
      drugs with limited dating. Each company has their own portal to manage
      listings, set price points, receive<br />
      bids, and process orders. All transactions on the channel are made
      directly between the ordering<br />
      healthcare system center and the source supplier. Pharmacies receive all
      shipments straight from the drug<br />
      company (or their preferred 3PL).
    </p>

    <span id="services-title" class="large-font font-teal"
      >What services does MedShorts provide?</span
    >
    <section id="provided-services-container">
      <div class="service-card">
        <div class="service-card-image-circles">
          <img
            class="service-card-image"
            src="/assets/img/static-pages/medshorts/static-pages-icons/Cloud_wht-01.png"
            alt="Server Cloud with Checkmark"
          />
        </div>
        <span class="medium-font font-teal">Digital solutions</span>
        <p class="body-font">
          Leverages matching algorithms<br />
          based on pharmacy usage to<br />
          increase exposure
        </p>
        <p class="body-font">Dynamic shelf-life pricing model</p>
        <p class="body-font">
          Waste/destruction cost mitigation<br />
          strategy
        </p>
      </div>
      <div class="service-card">
        <div class="service-card-image-circles">
          <img
            class="service-card-image"
            src="/assets/img/static-pages/medshorts/static-pages-icons/Market_wht-01.png"
            alt="Market Storefront"
          />
        </div>
        <span class="medium-font font-teal">Free market channel</span>
        <p class="body-font">
          Hosts a web-based pharmaceutical<br />
          marketplace to easily manage & sell<br />
          surplus stock to pharmacies
        </p>
        <p class="body-font">
          Option to enable bidding negotiations<br />
          on selected inventory
        </p>
        <p class="body-font">
          Portal orientation and various user<br />
          roles for your team
        </p>
      </div>
      <div class="service-card">
        <div class="service-card-image-circles">
          <img
            class="service-card-image"
            src="assets/img/static-pages/medshorts/static-pages-icons/Headphones_wht-01.png"
            alt="Customer Service Headphones"
          />
        </div>
        <span class="medium-font font-teal">Customer service</span>
        <p class="body-font">Billing and collections</p>
        <p class="body-font">
          Pharmacy customer care<br />
          (web chat, email, phone)
        </p>
        <p class="body-font">Real-time shipment tracking</p>
      </div>
    </section>
  </section>
</section>
<section class="manufacturer-enroll-section">
  <span class="medium-font font-teal">Start listing today!</span>
  <a href="/registration/seller"
    ><button
      id="manufacture-registar-btn"
      class="button-teal button-font bg-teal font-white"
    >
      Register here
    </button></a
  >
</section>
